import contactsView from "Modules/account/views/contacts/lan/es";
import loginHistoryView from "Modules/account/views/loginHistory/lan/es";
import changePasswordComponent from "Modules/account/.components/changePassword/lan/es";
import subUserView from "Modules/account/views/subUser/lan/es";
import permissionsView from "Modules/account/views/permissions/lan/es";
import apiKeysView from "Modules/account/views/apiKeys/lan/es";
import tagsView from "Modules/account/views/tags/lan/es";
import createEditTagComponent from "Modules/account/views/tags/components/createEditTag/lan/es";
import viewEntitiesComponent from "Modules/account/views/tags/components/viewEntities/lan/es";
import mergeTagsComponent from "Modules/account/views/tags/components/mergeTags/lan/es";
import roleView from "Modules/account/views/role/lan/es";
import deleteTagsComponent from "Modules/account/views/tags/components/deleteTags/lan/es";
import dataExportView from "Modules/account/views/dataExport/lan/es";
import WebHooksView from "Modules/account/views/webHooks/lan/es";
import modalImportTags from "Modules/account/views/tags/components/modalImportTags/lan/es";
import settingsView from "Modules/account/views/settings/lan/es";

const locales = {
  ...contactsView,
  ...loginHistoryView,
  ...changePasswordComponent,
  ...subUserView,
  ...permissionsView,
  ...apiKeysView,
  ...tagsView,
  ...createEditTagComponent,
  ...viewEntitiesComponent,
  ...mergeTagsComponent,
  ...roleView,
  ...deleteTagsComponent,
  ...dataExportView,
  ...WebHooksView,
  ...modalImportTags,
  ...settingsView,
};

export default locales;
